import React from 'react';
import Hero from '../components/Hero';
import ValuePropositions from '../components/ValuePropositions';
import PracticeAreas from '../components/PracticeAreas';
import MeetTheExpert from '../components/MeetTheExpert';
import ClientTestimonials from '../components/ClientTestimonials';
import LegalProcessTimeline from '../components/LegalProcessTimeline';
import FAQ from '../components/FAQ';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero 
        headline={["INSPIRED", "BY YOU.", "DRIVEN TO", "PROTECT YOU."]}
        tagline="Your story is our muse"
        definitionTerm="muse"
        definitions={[
          "A person or personified force who is the source of inspiration.",
          "The term originates from the Muses, ancient Greek goddesses of inspiration in the arts and sciences."
        ]}
        ctaButtons={[
          { text: "Contact us", href: "/contact", primary: true },
          { text: "How we work", href: "#about", primary: false }
        ]}
      />

      <section id="practice">
        <PracticeAreas 
          title="Practice Areas"
          subtitle="Comprehensive Personal Injury Representation"
          description="Expert legal advocacy for accident victims across California. We fight to get you the compensation you deserve."
        />
      </section>

      <section id="about" className="combined-section">
        <div className="combined-section-wrapper">
          <div className="combined-section-item">
            <MeetTheExpert 
              name="NATALIE ANTEKELIAN"
              title="PRINCIPAL ATTORNEY"
              company="MUSE LEGAL"
              imageUrl="/NatalieNew.png"
              ctaButtons={[
                { text: "SCHEDULE CONSULTATION", href: "/contact" },
                { text: "VIEW PROFILE", href: "/profile" }
              ]}
            />
          </div>
          
          <div className="combined-section-item">
            <ValuePropositions 
              subtitle="Why Choose Us"
              description="We deliver exceptional legal services with proven results and client satisfaction."
            />
          </div>
        </div>
      </section>

      <section id="testimonials">
        <ClientTestimonials 
          title="Client Testimonials"
          subtitle="What Our Clients Say"
          description="Real stories from real people who trusted us with their legal matters."
        />
      </section>

      <section id="process">
        <LegalProcessTimeline 
          title="Legal Process Timeline"
          subtitle="Your Journey to Justice"
          description="A clear, step-by-step guide to what you can expect when working with us."
        />
      </section>

      <section id="faq">
        <FAQ 
          title="Frequently Asked Questions"
          subtitle="We're Here to Help"
          description="Find answers to common questions about personal injury cases and working with our firm."
        />
      </section>

      <footer id="contact-footer" className="footer">
        <div className="footer-content">
          <div className="footer-left">
            <h2>Get in Touch</h2>
            <p className="footer-tagline">
              Ready to discuss your case? Contact us today for a free consultation.
            </p>
            <div className="footer-cta">
              <a href="tel:8182458888" className="footer-cta-button">
                Call Now
              </a>
            </div>
          </div>
          
          <div className="footer-right">
            <div className="footer-info">
              <h3 className="footer-info-title">Contact Information</h3>
              <div className="footer-info-item">
                <span className="footer-info-label">Email:</span>
                <span className="footer-info-value">admin@muselegalgroup.com</span>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-label">Phone:</span>
                <span className="footer-info-value">818-245-8888</span>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-label">Address:</span>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=15303+Ventura+Blvd+9th+Floor+Sherman+Oaks+CA+91403"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-info-value"
                  style={{ cursor: 'pointer', textDecoration: 'none' }}
                >
                  15303 Ventura Blvd 9th Floor, Sherman Oaks, CA 91403
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-left-bottom">
            <p className="footer-copyright">© 2025 Muse Legal Group. All rights reserved.</p>
            <div className="footer-legal-links">
              <a href="/privacy-policy" className="footer-legal-link">Privacy Policy</a>
              <span className="footer-legal-separator">|</span>
              <a href="/terms-and-conditions" className="footer-legal-link">Terms & Conditions</a>
            </div>
          </div>
          <div className="footer-brand">MUSE LEGAL</div>
        </div>
      </footer>
    </>
  );
};

export default HomePage;

